import React, {useEffect, useState} from "react";
import {Button, Select, Space} from "antd";
import {CheckOutlined, CloseOutlined, EditOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import {APPLICATION_STATUSES} from "constants/application";
import {ApplicationStatusTag} from "../common/ApplicationStatusTag";

export const ApplicationStatusEditor = ({type, application, canEdit, onChanged}) => {
    const {t} = useTranslation(["applications"]);
    const stores = useStore();
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(application.status);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setValue(application.status);
    }, [application.status]);

    const handleCancel = () => {
        setValue(application.status);
        setEditing(false);
    };

    const handleSave = async () => {
        setSaving(true);
        const result = await stores.applicationStore.updateApplicationStatus(
            type,
            application._id,
            {status: value}
        );
        setSaving(false);
        if (result) {
            setEditing(false);
            onChanged();
        }
    };

    if (!editing) {
        return (
            <Space>
                <ApplicationStatusTag status={application.status} />
                {canEdit && (
                    <Button
                        type="text"
                        size="small"
                        icon={<EditOutlined />}
                        title={t("detail.process.edit", {ns: "applications"})}
                        onClick={() => setEditing(true)}
                    />
                )}
            </Space>
        );
    }

    return (
        <Space>
            <Select value={value} onChange={setValue} style={{minWidth: 140}} disabled={saving}>
                {APPLICATION_STATUSES.map(status => (
                    <Select.Option key={status} value={status}>
                        {t(`statuses.${status}`, {ns: "applications"})}
                    </Select.Option>
                ))}
            </Select>
            <Button
                type="text"
                icon={<CheckOutlined />}
                title={t("detail.process.save", {ns: "applications"})}
                loading={saving}
                disabled={value === application.status}
                onClick={handleSave}
            />
            <Button
                type="text"
                icon={<CloseOutlined />}
                title={t("detail.process.cancel", {ns: "applications"})}
                disabled={saving}
                onClick={handleCancel}
            />
        </Space>
    );
};
